// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const DELETE_TEAM_EXTERNAL_GROUP_MAPPING =
  "mondoo.captain.Captain.DeleteTeamExternalGroupMapping";
